// allergensTranslations.js

const allergensTranslations = {
  es: {
    gluten: "Gluten",
    lacteos: "Lácteos",
    huevo: "Huevo",
    pescado: "Pescado",
    crustaceos: "Crustáceos",
    frutosSecos: "Frutos secos",
    altramuces: "Altramuces",
    cacahuete: "Cacahuete",
    apio: "Apio",
    mostaza: "Mostaza",
    sesamo: "Sésamo",
    soja: "Soja",
    moluscos: "Moluscos",
    dioxidoAzufre: "Dioxido de Azufre y Sulfitos",
  },
  en: {
    gluten: "Gluten",
    lacteos: "Dairy",
    huevo: "Egg",
    pescado: "Fish",
    crustaceos: "Crustaceans",
    frutosSecos: "Nuts",
    altramuces: "Lupin",
    cacahuete: "Peanut",
    apio: "Celery",
    mostaza: "Mustard",
    sesamo: "Sesame",
    soja: "Soy",
    moluscos: "Molluscs",
    dioxidoAzufre: "Sulphur Dioxide and Sulphites",
  },
  cat: {
    gluten: "Gluten",
    lacteos: "Làctics",
    huevo: "Ou",
    pescado: "Peix",
    crustaceos: "Crustacis",
    frutosSecos: "Fruits secs",
    altramuces: "Altramusos",
    cacahuete: "Cacauet",
    apio: "Api",
    mostaza: "Mostassa",
    sesamo: "Sèsam",
    soja: "Soja",
    moluscos: "Mol·luscos",
    dioxidoAzufre: "Diòxid de sofre i sulfits",
  },
  fr: {
    gluten: "Gluten",
    lacteos: "Produits laitiers",
    huevo: "Œuf",
    pescado: "Poisson",
    crustaceos: "Crustacés",
    frutosSecos: "Fruits à coque",
    altramuces: "Lupins",
    cacahuete: "Cacahuète",
    apio: "Céleri",
    mostaza: "Moutarde",
    sesamo: "Sésame",
    soja: "Soja",
    moluscos: "Mollusques",
    dioxidoAzufre: "Dioxyde de soufre et sulfites",
  },
};

export default allergensTranslations;
